module.exports = __webpack_public_path__ + "static/media/Pilots.d5880864.svg";